import { render, staticRenderFns } from "./pnlts.vue?vue&type=template&id=56e3b6b7&"
import script from "./pnlts.vue?vue&type=script&lang=js&"
export * from "./pnlts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports